<template>
    <div
        class="tw-flex tw-gap-2 tw-items-center tw-bg-white tw-p-2 tw-rounded-[3px] !tw-min-w-max"
    >
        <img :src="image" alt="logo" class="!tw-w-[40px] !tw-h-[30px]" />
        <div class="tw-flex tw-flex-col tw-flex-1">
            <p class="tw-text-[10px] tw-font-bold tw-text-[#404040]">
                {{ title }}
            </p>
            <div class="tw-flex tw-gap-2">
                <p class="tw-text-[10px] tw-font-bold tw-text-primary">
                    {{ price }}
                </p>
                <p
                    v-if="oldPrice !== null && oldPrice !== undefined"
                    class="tw-text-[10px] tw-text-[#606060] tw-line-through"
                >
                    {{ oldPrice }}
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{
    image: string
    title: string
    price: string | number
    oldPrice?: string | number | null
}>()
const { image, title, price, oldPrice } = props
</script>
